<ng-container *ngIf="(appModeService.appMode$|async) as currentAppMode">
  <!-- Loading bar -->
  <fuse-loading-bar></fuse-loading-bar>
  <ng-container *ngIf="{navigation: navigation$ | async, mediaChanges: mediaChanges$ | async} as o">
    <!-- Navigation -->
    <fuse-vertical-navigation
      *ngIf="currentAppMode !== appMode.SINGLE_QUESTION && currentAppMode !== appMode.EXTREPLY"
      class="dark bg-green-inbe print:hidden"
      [appearance]="navigationAppearance"
      [mode]="'side'"
      [name]="mainNavigationName"
      [navigation]="o.navigation.default"
      [opened]="!isSmallScreenSize(o.mediaChanges)"
      data-testId="verticalNavigationBar">
      <!-- Navigation header hook -->
      <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20">
          <img
            class="w-8"
            src="assets/images/logo/logo.svg"
            alt="Logo image">
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  </ng-container>
  <!-- Wrapper -->
  <div *ngIf="(userService.user$|async) as user" class="flex flex-col flex-auto w-full min-w-0"
       data-testId="denseComponentMainWrapper">

    <!-- Header -->
    <div
      id="header-row"
      data-testId="header"
      *ngIf="currentAppMode !== appMode.SINGLE_QUESTION"
      class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
      [class.public]="user.isPublic"
      [class.header-hidden]="appMode.REPLY && (smallAndLandscape$|async)"
    >

      <div class="flex items-center pr-2 space-x-2">

        <ng-container *ngIf="currentAppMode !== appMode.EXTREPLY">

          <ng-container *ngIf="!user.isPublic; else isPublicHeader">
            <!-- Navigation toggle button -->
            <button
              mat-icon-button
              (click)="toggleNavigation()">
              <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button
              class="hidden md:inline-flex"
              mat-icon-button
              (click)="toggleNavigationAppearance()">
              <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
            </button>
          </ng-container>

          <ng-template #isPublicHeader>

            <div class="flex items-center justify-center h-20">
              <img
                style="color: green;"
                class="w-8"
                src="assets/images/logo/logo.svg"
                alt="Logo image">
            </div>
            <span class="title ml-2 text-2xl text-white">inBe</span>

          </ng-template>

        </ng-container>

      </div>

      <!-- Components -->
      <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2"
           *ngIf="(userService.user$ | async) as user">
        <app-survey-reward-badge style="margin-right: auto;" [survey]="(surveyViewerService.activeSurvey$ | async)"></app-survey-reward-badge>
        <app-reward-call-to-action
          *ngIf="!user.isPublic && currentAppMode !== appMode.PREVIEW &&
                  (publicationAccessService.publication$ | async)?.pubUuid !== '2024b432-3554-47e5-9821-1e534d6d034f'"

        ></app-reward-call-to-action>


        <ng-container *ngIf="(appModeService.appMode$.value === 'preview')">
          <button
            [class.mat-stroked-button]="(appModeService.isDisplayRules$|async)"
            mat-icon-button
                  (click)="appModeService.isTestSurvey$.next(!(appModeService.isTestSurvey$.value))">
            <mat-icon>science</mat-icon>
          </button>
        </ng-container>

        <languages></languages>

        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>

        <!--            <search [appearance]="'bar'"></search>-->
        <!--            <shortcuts></shortcuts>-->
        <!--            <messages></messages>-->
        <!--            <notifications></notifications>-->
        <!--            <button-->
        <!--                class="lg:hidden"-->
        <!--                mat-icon-button-->
        <!--                (click)="quickChat.toggle()">-->
        <!--                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>-->
        <!--            </button>-->

        <user *ngIf="!user.isPublic"></user>

        <ng-container *ngIf="currentAppMode == appMode.EDIT_RESPONSE">
          <div class="w-48 overflow-hidden text-right">
            <div class="">
              [EDIT RESPONSE]
            </div>
            <div class="overflow-hidden">
              <p class="text-xs text-ellipsis">{{ user.id }} / {{ user.email }}</p>
            </div>
          </div>
        </ng-container>

      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
           Otherwise, layout changes won't be registered and the view won't be updated! -->

      <ng-container *ngIf="(appModeService.isTestSurvey$|async)">
<!--        <ng-container *ngIf="(appModeService.isDisplayRules$|async)">-->
          <as-split *ngIf="true" direction="horizontal" [gutterSize]="7">
            <as-split-area [size]="70">
              <router-outlet *ngIf="true"></router-outlet>
            </as-split-area>
            <as-split-area [size]="30">
              <app-test-survey></app-test-survey>
            </as-split-area>
          </as-split>
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!(appModeService.isDisplayRules$|async)">-->
<!--          <router-outlet *ngIf="true"></router-outlet>-->
<!--        </ng-container>-->
      </ng-container>

      <ng-container *ngIf="!(appModeService.isTestSurvey$|async)">
        <router-outlet *ngIf="true"></router-outlet>
      </ng-container>

      <!--      <ng-template #routerOutlet>-->
      <!--        <router-outlet *ngIf="true"></router-outlet>-->
      <!--      </ng-template>-->

      <!--      <router-outlet *ngIf="true"></router-outlet>-->


    </div>

    <!-- Footer -->
    <!--    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">-->
    <!--        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>-->
    <!--    </div>-->

  </div>

  <!-- Quick chat -->
  <!--  <quick-chat #quickChat="quickChat"></quick-chat>-->

</ng-container>

